import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { TextInputField, PasswordInputField, SelectField, CheckBoxField, PhoneInputField,
  MoneyInputField, DEFAULT_REQUIRED_MESSAGE, PHONE_INVALID_MESSAGE
  } from 'common/components/form_fields';
import ChangePassword from 'account/containers/change_password';
import { isPhoneValid } from 'common/utils';


const Step2Form = ({error, handleSubmit, submitting, submitFailed, tzChoices, leadChoices,
                    categoryChoices, industryChoices, showLeadSourceField, lazyRegistered}) => (

  <form onSubmit={handleSubmit}>

    { lazyRegistered &&
    <fieldset>
      <h4>Username</h4>
      <p>Your username is your public name on the site. It's how creatives will
         know you. It's important to choose something unique and professional.</p>

      <Field name="username" label="Username" component={TextInputField} />

      <h4>Password</h4>
      <ChangePassword noConfirmation={true}/>
    </fieldset> }

    <fieldset>
      <h4>Contact Info</h4>

      <Field name="first_name" label="First Name" component={TextInputField} />
      <Field name="last_name" label="Last Name" component={TextInputField} />
      <Field name="phone_number" label="Phone" component={PhoneInputField}/>
      <Field name="user_timezone" label="Timezone" component={SelectField} options={tzChoices}/>
    </fieldset>

    { !lazyRegistered &&
    <fieldset>
      <h4>Your Project</h4>
      <p>Tell us a bit more about what kind of project you want to post.</p>

      <Field name="preferred_category" label="Category" component={SelectField}
             options={categoryChoices} allowEmpty={true}/>
      <Field name="preferred_industry" label="Industry" component={SelectField}
             options={industryChoices} allowEmpty={true}/>
      <div className="row">
        <div className='columns small-16 medium-8'>
          <Field name="preferred_budget" label="Budget" component={MoneyInputField} />
        </div>
      </div>
    </fieldset> }

    <fieldset>
      <h4>Keep in touch?</h4>

      <Field name="receive_communication" component={CheckBoxField}
             label={"Crowdspring can email me from time to time with useful information.\
                    We'll never sell your information."}/>
      {showLeadSourceField &&
      <Field name="lead_source" label="How did you hear about us?" component={SelectField}
             options={leadChoices} allowEmpty={true}/>}
    </fieldset>

    <fieldset>
      <h4>Play By the Rules</h4>

      <Field name="accepted_terms_of_use" component={CheckBoxField}
             label={<span>I agree to the <a>Standard of Conduct</a> and <a>User Agreement</a>.</span>}/>
    </fieldset>

    <AnimatedButton processing={submitting} type="submit" label="Create account"
      processingLabel="Creating..." errorMsg={error || submitFailed} successMsg="Account Created!"/>

  </form>
)

const validate = (values) => {
  const errors = {};
  const requiredFields = ['first_name', 'last_name', 'phone_number',
                          'preferred_category', 'preferred_industry', 'preferred_budget',
                          'lead_source', 'username']

  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE
  }
  if (!values.accepted_terms_of_use) {
    errors.accepted_terms_of_use = 'You must agree to our policies before proceeding'
  }
  if (values.phone_number && !isPhoneValid(values.phone_number)) {
    errors.phone_number = PHONE_INVALID_MESSAGE
  }
  return errors
}

export default reduxForm({
  form: "Step2Form",
  validate,
})(Step2Form);



// WEBPACK FOOTER //
// ./registration/client/components/step2_form.jsx